import { Select } from "antd";
import { SelectDropdown } from "themes/Icon";
import "./select.scss";

function SelectComp({
  label,
  id,
  data,
  className = "",
  placeholder,
  onChange,
  value,
  onClear,
  disabled = false,
  allowClear = true,
}) {
  return (
    <div className="flex flex-column gap-2">
      {label && (
        <label className="input-label" htmlFor={id}>
          {label}
        </label>
      )}
      <Select
        id={id}
        suffixIcon={!disabled && <SelectDropdown />}
        allowClear={allowClear}
        style={{ width: "100%" }}
        value={value}
        className={`chip-select color-select ${className}`}
        popupClassName="select-popover color-select-popover"
        placeholder={placeholder}
        options={data}
        onChange={onChange} // Add the onChange here
        onClear={onClear}
        disabled={disabled}
      />
    </div>
  );
}

export default SelectComp;
